import Create from "./Create";
import Edit from "./Edit";
import List from "./List";
import { ResearchProjectIcon } from "../icons";

const config = {
  options: {
    group: "dashboard",
    roles: ["admin", "user", "reader", "president"],
    to: `/research-projects?filter=${JSON.stringify({})}`,
    active: (location) => {
      // Lo stato di selezione attiva per questa voce di menu si verifica
      // solo se l'utente non ha selezionato uno degli altri report previsti
      // per la consultazione dei progetti di ricerca inoltrati.
      const params = new URLSearchParams(location.search);
      const filter = JSON.parse(params.get("filter") || "{}");

      return (
        location.pathname.startsWith("/research-projects") &&
        (!filter || filter?.view !== 1)
      );
    },
  },
  icon: ResearchProjectIcon,
  list: List,
  edit: Edit,
  create: Create,
};

export default config;
